/* Odyssey checkout routing (Oct 19 2026, Yannick: "whichever they click is wherever they go").
   - Main Checkout / Buy Now buttons  -> the Whop checkout at checkout.odysseyproductsshop.com, carrying the
     Shopify cart (variants, quantities, subscription plans), currency, country and discount codes.
   - "Buy with Shop Pay" buttons       -> Shopify's own checkout with Shop Pay opened, exactly as before.
   Kill switch: set ODY_WHOP_CHECKOUT to '' and every button goes to Shopify's checkout again.
   Every theme script that jumps straight to /checkout calls window.odyGoCheckout first (Oct 19 2026); forms
   that used return_to=/checkout now return to /cart?ody_checkout=1, which this script forwards. As a safety
   net for jumps added later, browsers with the Navigation API also have any plain /checkout navigation
   redirected here (Shop Pay's /checkout?payment=shop_pay is left alone).
   Attribution (Oct 20 2026): orders made through the Whop checkout get no Conversion summary in Shopify, so
   this script keeps what Shopify's own checkout would have known (UTMs, click ids, landing page, referrer,
   Shopify's visitor id) and hands it over as ?attr=; the checkout stamps it on the Shopify order. */
(function () {
  'use strict';
  var ODY_WHOP_CHECKOUT = 'https://checkout.odysseyproductsshop.com/checkout';
  var toShopify = false; // set right before we deliberately open Shopify's checkout

  function shopifyCheckout(path, noMat) {
    // Price test version B (Oct 23 2026): Shopify's checkout would charge more than B was shown for the mat. If
    // the Whop checkout can't be reached, B goes back to the cart instead, unless the cart is known to hold no mat.
    if (window.odyMatPriceTest && !noMat) { window.location.href = '/cart'; return; }
    toShopify = true;
    window.location.href = path || '/checkout';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function cartToUrl(cart, direct, noCodes, onlyCodes) {
    var items = direct ? direct.map(function (it) {
      // whop_plan: a plan only the Whop checkout knows (Chalk Supply Subscribe & Save 'packsub', Oct 25 2026); the Shopify cart add skips it.
      return it.id + ':' + it.quantity + (it.selling_plan ? ':' + it.selling_plan : it.whop_plan ? ':' + it.whop_plan : '');
    }) : (cart.items || []).map(function (it) {
      var a = it.selling_plan_allocation;
      var plan = a && a.selling_plan ? ':' + a.selling_plan.id : '';
      return it.variant_id + ':' + it.quantity + plan;
    });
    var codes = [];
    (cart.cart_level_discount_applications || []).concat(
      (cart.items || []).reduce(function (all, it) { return all.concat(it.line_level_discount_allocations || []); }, [])
        .map(function (d) { return d.discount_application || {}; })
    ).forEach(function (d) {
      if (d && d.type === 'discount_code' && d.title && codes.indexOf(d.title) === -1) codes.push(d.title);
    });
    // Codes saved on the cart even when no line uses them yet (e.g. an empty cart before a Buy Now).
    (cart.discount_codes || []).forEach(function (d) { if (d && d.code && codes.indexOf(d.code) === -1) codes.push(d.code); });
    // A code from a /discount/CODE link that is not on the cart yet.
    var dc = cookie('discount_code');
    if (dc && /^[^,]{1,64}$/.test(dc) && codes.indexOf(dc) === -1) codes.push(dc);
    // A page that owns the code (athlete pages, Oct 25 2026) sends exactly that code, never a stale one from the cart.
    if (onlyCodes && onlyCodes.length) codes = onlyCodes.filter(function (c) { return c && /^[^,]{1,64}$/.test(c); });
    if (noCodes) codes = [];
    var p = new URLSearchParams();
    p.set('items', items.join(','));
    var cur = cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    if (cur) p.set('cur', cur);
    var country = (window.Shopify && window.Shopify.country) || '';
    if (country) p.set('country', country);
    if (codes.length) p.set('codes', codes.join(','));
    var token = cart.token || cookie('cart');
    if (token) p.set('ct', String(token).split('?')[0]);
    // Attribution the storefront already holds (UTMs from the landing URL, affiliate refs in cart attributes),
    // then this session's landing URL params as a backup (kept in sessionStorage by firstTouch below).
    var attrs = cart.attributes || {}, ft = firstTouch();
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref', 'trybe'].forEach(function (k) {
      if (attrs[k]) p.set(k, attrs[k]); else if (ft[k]) p.set(k, ft[k]);
    });
    // GoAffPro keeps the affiliate from ?ref= links in a "ref" cookie (Oct 20 2026), not in cart attributes.
    // Pass it on so referral-link sales are credited even when no code is on the cart.
    if (!p.has('ref')) {
      var ref = '';
      document.cookie.split(/;\s*/).forEach(function (c) {
        var i = c.indexOf('=');
        if (i > 0 && c.slice(0, i) === 'ref') {
          var v = decodeURIComponent(c.slice(i + 1));
          if (/^[A-Za-z0-9_.-]{1,64}$/.test(v)) ref = v;
        }
      });
      if (ref) p.set('ref', ref);
    }
    // Where this browser came from (see attribution below), for the Shopify order's attribution.
    try {
      var at = attribution(), pack = {};
      if (at.f) pack.f = at.f;
      if (at.l) pack.l = at.l;
      var y = cookie('_shopify_y'), s = cookie('_shopify_s'), ab = cookie('odab_src'), fbp = cookie('_fbp'), fbc = cookie('_fbc');
      if (y) pack.y = y.slice(0, 64);
      if (s) pack.s = s.slice(0, 64);
      if (ab) pack.src = ab.slice(0, 200);
      // Split-test versions (e.g. mat-price:B): the checkout charges the price test's version B price from this.
      var abAll = cookie('odab_all');
      if (abAll) pack.ab = abAll.slice(0, 120);
      // Meta's own ids from the store (browser id, click id), so the checkout's server-side Purchase matches
      // the ad click even when its own host never got the cookies.
      if (fbp) pack.p = fbp.slice(0, 200);
      if (fbc) pack.c = fbc.slice(0, 300);
      // Trybe's visitor and session ids (its Shopify pixel), so the Whop server can tell Trybe about the sale
      // and the creator gets the credit (Oct 21 2026). Its ad id rides in the pixel's session params.
      var tv = cookie('ugc_vid_eded60ac-5ffe-4e86-a8a8-a3685801a1b2');
      if (tv) pack.tv = tv.slice(0, 64);
      try {
        var ts = sessionStorage.getItem('ugc_session_id');
        if (ts) pack.ts = ts.slice(0, 64);
        var tp = JSON.parse(sessionStorage.getItem('ugc_tracking_params') || 'null');
        if (tp && tp.params && tp.params.trybe_adid) pack.ta = String(tp.params.trybe_adid).slice(0, 64);
      } catch (e) {}
      if (Object.keys(pack).length) p.set('attr', JSON.stringify(pack));
      // Older checkout builds read the plain params: fill them from the latest touch when the cart had none.
      if (at.l) ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (!p.has(k) && at.l[k]) p.set(k, at.l[k]); });
    } catch (e) {}
    try { var L = window.OdyI18n; if (L && L.lang && L.lang !== L.primaryLang) p.set('lang', L.lang); } catch (e) {}
    return ODY_WHOP_CHECKOUT + '?' + p.toString();
  }

  function cookie(name) {
    var v = '';
    document.cookie.split(/;\s*/).forEach(function (c) {
      var i = c.indexOf('=');
      if (i > 0 && c.slice(0, i) === name && !v) { try { v = decodeURIComponent(c.slice(i + 1)); } catch (e) { v = ''; } }
    });
    return v;
  }
  function firstTouch() {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'trybe'], ft = {};
    try { ft = JSON.parse(sessionStorage.getItem('ody_ft') || '{}') || {}; } catch (e) { ft = {}; }
    try {
      var q = new URLSearchParams(window.location.search), changed = false;
      keys.forEach(function (k) { var v = q.get(k); if (v && !ft[k] && v.length < 200) { ft[k] = v; changed = true; } });
      if (changed) sessionStorage.setItem('ody_ft', JSON.stringify(ft));
    } catch (e) {}
    return ft;
  }
  firstTouch();

  /* ATTRIBUTION (Oct 20 2026). What Shopify's own sessions would have recorded for a Shopify-checkout order,
     kept in localStorage 'ody_attr' for 30 days (Shopify's own attribution window): the first arrival in that
     window and the latest arrival. An arrival is a page load with campaign params on the URL (utm_*, fbclid,
     ttclid, gclid, msclkid, trybe, ref) or a referrer from another site, each with its landing page and referrer.
     Moving around the site is not an arrival. Nothing here is sent anywhere until the buyer goes to checkout. */
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'gclid', 'msclkid', 'trybe', 'ref'];
  function attribution() {
    var store = {};
    try { store = JSON.parse(localStorage.getItem('ody_attr') || '{}') || {}; } catch (e) { store = {}; }
    try {
      var now = Date.now();
      if (!store.f || !store.f.at || now - store.f.at > 30 * 864e5) store = {};
      var q = new URLSearchParams(window.location.search), touch = { at: now }, tagged = false;
      ATTR_KEYS.forEach(function (k) { var v = q.get(k); if (v && v.length < 250) { touch[k] = v; tagged = true; } });
      var rf = document.referrer || '', external = false;
      if (rf) { try { external = new URL(rf).hostname.replace(/^www\./, '') !== window.location.hostname.replace(/^www\./, ''); } catch (e) { external = false; } }
      if (tagged || external || !store.l) {
        touch.lp = window.location.href.slice(0, 500);
        if (rf) touch.rf = rf.slice(0, 300);
        if (!store.f) store.f = touch;
        store.l = touch;
        localStorage.setItem('ody_attr', JSON.stringify(store));
      }
    } catch (e) {}
    return store;
  }
  attribution();

  /* FAST PATH (Oct 20 2026, Yannick: "they click Buy Now, and it goes straight to the checkout ... no lag").
     Buy Now pages call window.odyBuyNow(items) with the exact lines they would have added. The Whop URL is built
     from those lines plus a cart snapshot read in the background (codes, cart token, app attributes), so the
     tap navigates at once. The Shopify cart still gets the add (keepalive, never blocks) for analytics and
     abandoned-cart. opts.noCodes: send no discount code (ad landing pages). opts.codes: send only these codes (athlete pages). Returns false when it cannot run (kill switch, no lines), so the page uses its old path. */
  var snap = null, snapAt = 0;
  function warm() {
    if (Date.now() - snapAt < 5000) return;
    snapAt = Date.now();
    getCart().then(function (c) { snap = c; }).catch(function () {});
  }
  window.odyWarmCheckout = warm;
  window.odyBuyNow = function (lines, opts) {
    opts = opts || {};
    if (!ODY_WHOP_CHECKOUT || !lines || !lines.length) return false;
    // Free chalk with a mat is off (snippets/mat-chalk-on): never pass a gift bottle on.
    var matChalk = opts.matChalk !== undefined ? opts.matChalk : window.MAT_CHALK;
    if (matChalk !== true) lines = lines.filter(function (l) { return !(l.selling_plan === 4945739988 || l.id === 67862385721556); });
    lines = lines.filter(function (l) { return l.id && l.quantity > 0 && l.id !== 46821620809940; }); // never shipping protection
    if (!lines.length) return false;
    // Split tests count this as reaching checkout (snippets/odyssey-ab.liquid; Buy Now isn't a checkout link).
    try { if (window.odysseyABEvent) window.odysseyABEvent('ab_checkout'); } catch (e) {}
    var url;
    try { url = cartToUrl(snap || {}, lines, opts.noCodes, opts.codes); } catch (e) { return false; }
    // opts.params: extra query params for the checkout (Max launch offer preview, Nov 1 2026).
    if (opts.params) { var u2 = new URL(url); Object.keys(opts.params).forEach(function (k) { u2.searchParams.set(k, opts.params[k]); }); url = u2.toString(); }
    try {
      fetch('/cart/add.js', { method: 'POST', keepalive: true, credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines.map(function (l) { var o = { id: l.id, quantity: l.quantity }; if (l.selling_plan) o.selling_plan = l.selling_plan; if (l.properties) o.properties = l.properties; return o; }) }) });
    } catch (e) {}
    window.location.href = url;
    return true;
  };
  // Snapshot the cart once the page is idle, and again whenever a finger or mouse goes down (before the click).
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 }); else setTimeout(warm, 1500);
  document.addEventListener('pointerdown', warm, { capture: true, passive: true });

  // Main checkout path. Falls back to Shopify's checkout if anything goes wrong, so a sale is never lost.
  window.odyGoCheckout = function () {
    try { if (window.odysseyABEvent) window.odysseyABEvent('ab_checkout'); } catch (e) {}
    if (!ODY_WHOP_CHECKOUT) { shopifyCheckout(); return Promise.resolve(); }
    return getCart()
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { window.location.href = '/cart'; return; }
        /* Gift cards (Oct 21 2026): Shopify only issues the code in its own checkout, so any cart holding one goes there. */
        /* Signature Tee (Oct 25 2026): the Whop checkout doesn't carry the shirt and Shopify's Tapstitch delivery
           profile holds its free shipping, so any cart holding one goes there too (sections/shirt-lp.liquid). */
        if (cart.items.some(function (it) { return it.gift_card || it.handle === 'odyssey-signature-premium-t-shirt'; })) {
          var t = window.odyMatPriceTest;
          shopifyCheckout('/checkout', !t || !cart.items.some(function (it) { return it.variant_id === t.variant || (t.chalk && it.variant_id === t.chalk.variant) || (t.bundles || []).some(function (b) { return b.v === it.variant_id; }); }));
          return;
        }
        window.location.href = cartToUrl(cart);
      })
      .catch(function () { shopifyCheckout(); });
  };

  // Shop Pay path: Shopify's checkout with Shop Pay opened straight away.
  window.odyGoShopPay = function () {
    // Price test version B (Oct 23 2026): Shopify's checkout would charge version A's mat price, so B goes to the
    // Whop checkout, which charges what B was shown.
    if (window.odyMatPriceTest && ODY_WHOP_CHECKOUT) return window.odyGoCheckout();
    shopifyCheckout('/checkout?payment=shop_pay');
  };

  // Forms that add to cart with return_to land on /cart?ody_checkout=1: continue to the Whop checkout.
  if (/[?&]ody_checkout=1/.test(window.location.search)) window.odyGoCheckout();

  // Safety net: a script elsewhere doing location.href = '/checkout' still ends up on the Whop checkout.
  if (ODY_WHOP_CHECKOUT && window.navigation && window.navigation.addEventListener) {
    window.navigation.addEventListener('navigate', function (e) {
      if (toShopify || !e.cancelable || e.hashChange || e.downloadRequest) return;
      var u;
      try { u = new URL(e.destination.url); } catch (err) { return; }
      if (u.origin !== window.location.origin || !/^\/checkout\/?$/.test(u.pathname) || u.searchParams.has('payment')) return;
      e.preventDefault();
      window.odyGoCheckout();
    });
  }

  // Any plain link or cart-page form that still points at /checkout takes the main path too.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="/checkout"], a[href$="/checkout"]');
    if (!a || a.hasAttribute('data-ody-shoppay')) return;
    e.preventDefault();
    window.odyGoCheckout();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, s = e.submitter;
    if (!f || !/\/cart(\?|$)/.test(f.getAttribute('action') || '')) return;
    if (s && s.name === 'checkout' && !s.hasAttribute('data-ody-shoppay')) {
      e.preventDefault();
      window.odyGoCheckout();
    }
  }, true);
})();
